import { sessionStorageUtil } from "./storage";

export class NotificationAPI {
	baseURL
	email
	token
  constructor(baseURL) {
	this.baseURL = process.env.REACT_APP_API_BASE_URL;
	this.email = process.env.REACT_APP_API_GUEST_EMAIL;
	this.token = process.env.REACT_APP_API_GUEST_TOKEN;
  }

  async request(endpoint, options = {}) {
    // const token = sessionStorageUtil.getAccessToken();
    const response = await fetch(`${this.baseURL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${this.token}`,
        ...options.headers,
      },
    });

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    return response.json();
  }

  async getUnreadCount() {
    const data = await this.request('/notifications/unread-count');
    return data.count;
  }

  async getNotifications(since, data) {
    const params = new URLSearchParams();
    if (since) params.append('since', since);
	params.append('email', this.email);
	params.append('amc_code', sessionStorageUtil.getAmcCode());
	params.append('folio_no', data.folio_no);
    return this.request(`/notifications?${params.toString()}`);
  }

  async markAsRead(folioNo, notificationIds) {
    try {
      const data = await this.request(`/notifications/mark-as-read`, {
        method: 'POST',
        body: JSON.stringify({
          email: this.email,
          folio_no: folioNo,
          notifications: notificationIds
        }),
      });

      if (!data) {
        throw new Error('Failed: Mark Notifications Read')
      }

      // console.log(data)
      return data;

    } catch (e) {
      // console.log(e)
      throw new Error(e.message)
    }
  }

  startPolling(
    onNewNotifications,
    intervalMs = 5 * 60 * 1000,
	args
  ) {
    let lastFetchTime = null;

    const poll = async () => {
      try {
        const since = lastFetchTime || new Date(Date.now() - intervalMs).toISOString();
        const data = await this.getNotifications(since, args);
        
        lastFetchTime = new Date().toISOString();

        if (data.notifications.length > 0) {
          onNewNotifications(data.notifications, data.unreadCount);
        }
      } catch (error) {
        // console.error('Notification polling failed:', error);
      }
    };

    // Initial fetch
    poll();

    // Start interval
    return setInterval(poll, intervalMs);
  }
}

// React Usage Example
export const notificationAPI = new NotificationAPI(process.env.REACT_APP_API_BASE_URL);